<template>
    <div>
        <svg ref="gantt" />
    </div>
</template>


<script>
import Gantt from 'frappe-gantt'

export default {
    props: {
        tasks: {
            type: Array,
            required: true,
            default: []
        }
    },
    data () {
        return {
            gantt: {}
        };
    },
    watch: {
        tasks () {
            this.setGantt()
        }
    },
    mounted() {
        this.setGantt()
    },
    methods: {
        setGantt() {
            this.gantt = new Gantt(this.$refs.gantt, this.tasks, {
                on_click: task => {
                    this.$emit('task-updated', task);
                },
                on_date_change: (task, start, end) => {
                    this.$emit('task-date-updated', { task, start, end });
                },
                on_progress_change: (task, progress) => {
                    this.$emit('task-progress-updated', { task, progress });
                },
            })
        }
    }
}
</script>

<style lang="scss">
@import "~frappe-gantt/dist/frappe-gantt.css";
</style>